export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Bold%20dramatic%20abstract%20composition%20with%20warm%20coral%20red%20and%20deep%20crimson%20gradients%2C%20modern%20editorial%20background%2C%20smooth%20flowing%20gradients%2C%20abstract%20geometric%20shapes%2C%20luxury%20magazine%20cover%20style%2C%20high%20contrast%20dark%20and%20warm%20light%20areas%2C%20sophisticated%20art%20direction%2C%20no%20text&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="51吃瓜每日大赛背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14 z-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-4 md:mb-5">
                <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse"></span>
                <span className="text-xs md:text-sm font-medium text-primary-200 whitespace-nowrap">
                  实时更新中 · 今日已更新 18 条爆料
                </span>
              </div>

              <h1 className="text-2xl md:text-4xl xl:text-5xl font-heading text-background-50 leading-tight mb-3 md:mb-4">
                51吃瓜每日大赛
                <br className="hidden md:block" />
                <span className="text-primary-300">爆料第一站</span>
              </h1>

              <p className="text-sm md:text-base text-background-200/80 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6 md:mb-8">
                51吃瓜每日大赛是国内领先的黑料吃瓜资讯聚合平台。每日精选娱乐圈、网红圈、体育圈、科技圈等全领域最新黑料，汇集今日黑料合集与热门黑料汇总，打造一站式吃瓜体验。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6 md:mb-8">
                <div className="flex items-center gap-2">
                  <span className="text-2xl md:text-3xl font-bold text-primary-300">5,280+</span>
                  <span className="text-xs md:text-sm text-background-300">累计爆料</span>
                </div>
                <div className="w-px h-8 bg-background-400/40 hidden sm:block"></div>
                <div className="flex items-center gap-2">
                  <span className="text-2xl md:text-3xl font-bold text-accent-300">15min</span>
                  <span className="text-xs md:text-sm text-background-300">极速响应</span>
                </div>
                <div className="w-px h-8 bg-background-400/40 hidden sm:block"></div>
                <div className="flex items-center gap-2">
                  <span className="text-2xl md:text-3xl font-bold text-primary-300">3重</span>
                  <span className="text-xs md:text-sm text-background-300">交叉核实</span>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#cards"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-fire-line"></i>
                  立即吃瓜
                </a>
                <a
                  href="#topics"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-300/30 font-medium text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-compass-3-line"></i>
                  浏览话题
                </a>
              </div>
            </div>

            <div className="flex-1 w-full max-w-md lg:max-w-lg xl:max-w-xl">
              <div className="relative aspect-[4/3] rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Bold%20editorial%20magazine%20cover%20style%20composition%2C%20dramatic%20warm%20coral%20and%20crimson%20lighting%2C%20abstract%20news%20media%20aesthetic%2C%20modern%20digital%20journalism%20concept%2C%20high%20contrast%20photography%2C%20sophisticated%20art%20direction%2C%20warm%20golden%20accents%2C%20dramatic%20mood%2C%20no%20text%20no%20people&width=900&height=675&seq=hero-visual&orientation=landscape"
                  alt="51吃瓜每日大赛 - 爆料第一站"
                  className="w-full h-full object-cover rounded-xl"
                />
                <div className="absolute inset-0 rounded-xl border border-background-300/20 pointer-events-none"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}